<!-- @format -->

<contracts-tag>
<h2 class="ui header">個別契約書類</h2>
<div class="ui hidden divider"></div>
<div class="ui breadcrumb">
  <a href="/croco-desk" class="section">トップページ</a>
  <div class="divider"> / </div>
  <div class="active section">個別契約書類</div>
</div>
<div class="ui basic segment">
  <template each={file in state.files}>
    <div class="ui steps">
      <a class="active step" onclick={(e)=>download(e, file)}>
        <i class="download icon"></i>
        <div class="content">
          <div class="title">{file.name}</div>
          <div class="description">ダウンロード</div>
        </div>
      </a>
    </div>&nbsp;
  </template>
</div>
<script>
  import di from "dependency-injection";

  export default {
    state: {
      files: []
    },
    download(e, file){
      this.CrocoDeskApi.request('contracts', 'download', {id: file.id})
        .then(data=>{
          if (data) {
            location.href = data;
          } else {
            di.toast.push("ダウンロードに失敗しました", "negative");
          }
        })
    },
    onBeforeMount(){
      this.CrocoDeskApi = di.createApi();

      this.CrocoDeskApi.request('contracts', 'fetch')
        .then(data => this.update({files: data}))
    }
  }
</script>
</contracts-tag>
